var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',{staticClass:"px-3 py-2 transition-colors duration-100 text-sm hover:bg-gray-lightest hover:text-gray-light",class:_vm.isActive ? 'bg-secondary text-white' : 'text-gray-700',attrs:{"value":_vm.value,"label":_vm.label},on:{"click":function($event){return _vm.setOption(_vm.value, _vm.label)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }